<div class="flex-content">
  <div *ngFor="let team of team$ | async" class="content col-sm container-fluid">

    <div class="col-sm-12 imgDiv" [style.background-image]="'url(' + imgPath + team.img + ')'">

    </div>

    <div class="row no-gutters">

      <div class="col-sm-12 team">
        <!-- <h2 class="yellow">{{team.fullname}}</h2> -->
        <h2 class="yellow" *ngIf="!isTeam(team.shortname)">{{isShowTeam(team.shortname)}}</h2>
        <h2 *ngIf="isTeam(team.shortname)">{{isShowTeam(team.shortname)}}</h2>
        <p class="yellow" *ngIf="isTeam(team.shortname)">{{team.fullname}}</p>
        <p>{{team.desc}}</p>
      </div>

      <div class="col-sm-12 related">
        <h2>Related Thesis</h2>

        <div *ngFor='let publication of team.publications| orderBy:order:ascending' >
          <a [routerLink]="['/main/international/individual/' + publication.id]" class="links">{{publication.title}},
            <span>{{publication.year}}</span>
          </a>
        </div>

      </div>

      <div class="col-sm-12 related">
        <h2>Related Projects</h2>

        <div *ngFor='let project of team.projects| orderBy:order:ascending'>
          <a *ngIf="project.fullname" [routerLink]="['/main/projects/individual/' + project.id]" class="links">{{project.fullname}},
            <span>{{project.year}}</span>
          </a>
        </div>

      </div>


      <!-- <div class="col-12 project-manager">
        <h2 class="people-status col-sm-12">

          Members
        </h2>

        <div class="box-flex row">
          <div [ngClass]="{'teamLeader': (person.status.length > 0) }" (click)="routing(person.id)" *ngFor="let person of team.people" class="people-box pad col-sm-12 col-md-6">
            <div class="people-img">
              <div class="people-img-box">
                <img default="./../../../../assets/Contents/imgs/no_image.jpg" [srcset]=" imgPath + person.img" [src]=" imgPath + person.img">
              </div>
            </div>

            <div class="people-text" >
              <p class="menu02">name</p>
              <h5>{{person.name}} </h5>
              <p class="menu02">topics</p>
              <p>{{person.topics}}</p>
              <p class="menu02">email</p>
              {{person.email}}
              <p class="menu02" *ngIf="person.status?.length > 0">status</p>
              {{person.status}}
            </div>
          </div>
        </div>

      </div> -->


    </div>
  </div>
</div>



// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/main/main-content/research-area-individual/research-area-individual.component.html